/* Genuine Suede — header dropdowns open on hover on desktop (like qomfortco.com); click still works */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  function bind() {
    document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
      if (details.dataset.gsHover) return;
      details.dataset.gsHover = '1';
      var summary = details.querySelector('summary');
      var timer;
      details.addEventListener('mouseenter', function () {
        if (!canHover || !canHover.matches) return;
        clearTimeout(timer);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });
      // With a mouse the menu is already open on hover, so a click on the parent goes to its page
      // (e.g. "About us" -> /pages/about-us), exactly like qomfortco.com. Touch and keyboard keep the toggle.
      if (summary && summary.dataset.gsHref && summary.dataset.gsHref !== '#') {
        summary.addEventListener('click', function (event) {
          if (!canHover || !canHover.matches || event.detail === 0) return;
          event.preventDefault();
          window.location.href = summary.dataset.gsHref;
        });
      }
      details.addEventListener('mouseleave', function () {
        if (!canHover || !canHover.matches) return;
        timer = setTimeout(function () {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 150);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
